





// import axios from "axios"
// import { post, del, get, put } from "./api_helper"
// import * as url from "./url_helper"

// // Create Class
// export const createTrainingEntry = data => post(url.CREATE_TRAINING, data);
// export const updateTraining = data => put(url.UPDATE_TRAINING, data);
// export const deleteTrainingEntry = id => del(url.DELETE_TRAINING + id);
// export const fetchSingleTraining = id => del(url.FETCH_SINGLE_TRAINING + id);
// export const fetchAllTraining = () => get(url.FETCH_ALL_TRAINING);
// export const fetchTrainerWithTraining = id => get(url.FETCH_TRAINERS_WITH_TRAINING + id);

// // NEW: Fetch exam data for a specific batch
// export const fetchBatchExamData = (batchId, fromDate = null, toDate = null) => {
//   let params = { batchId };
  
//   if (fromDate) {
//     params.fromDate = fromDate;
//   }
  
//   if (toDate) {
//     params.toDate = toDate;
//   }
  
//   return axios.get('/api/exams/batch-exams', { params });
// };

// // Alternative: If you have an endpoint that returns all exams with batch info
// export const fetchAllExamsWithBatchInfo = (organizationId, fromDate = null, toDate = null) => {
//   let params = { organizationId };
  
//   if (fromDate) {
//     params.fromDate = fromDate;
//   }
  
//   if (toDate) {
//     params.toDate = toDate;
//   }
  
//   return axios.get('/api/exams/all-with-batch', { params });
// };

// // If you need to fetch exam attempts directly
// export const fetchExamAttemptsByBatch = (batchId) => {
//   return axios.get(`/api/exam-attempts/batch/${batchId}`);
// };

// // Fetch trainings by month - UPDATED to use the url helper
// export const fetchTrainingsByMonth = async (year, month) => {
//     try {
//         const authUser = JSON.parse(localStorage.getItem("authUser"));
//         const organizationId = authUser?.organizationId || authUser?.organization?.id;
        
//         if (!organizationId) {
//             throw new Error("Organization ID not found");
//         }
        
//         // Use axios with the url helper pattern
//         const response = await axios.get(`${url.GET_TRAININGS_BY_MONTH}`, {
//             params: {
//                 organizationId: organizationId,
//                 year: year,
//                 month: month
//             },
//             headers: {
//                 'Content-Type': 'application/json',
//                 'Authorization': `Bearer ${localStorage.getItem('token')}`
//             }
//         });
        
//         return response.data;
//     } catch (error) {
//         console.error("Error fetching trainings by month:", error);
//         throw error;
//     }
// };






import axios from "axios";
import { post, del, get, put } from "./api_helper";
import * as url from "./url_helper";

// Create Class
export const createTrainingEntry = data => post(url.CREATE_TRAINING, data);
export const updateTraining = data => put(url.UPDATE_TRAINING, data);
export const deleteTrainingEntry = id => del(url.DELETE_TRAINING + id);
export const fetchSingleTraining = id => get(url.FETCH_SINGLE_TRAINING + id);
export const fetchAllTraining = () => get(url.FETCH_ALL_TRAINING);
export const fetchTrainerWithTraining = id => get(url.FETCH_TRAINERS_WITH_TRAINING + id);

// Fetch trainings by month
export const fetchTrainingsByMonth = async (year, month) => {
    try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const organizationId = authUser?.organizationId || authUser?.organization?.id;
        
        if (!organizationId) {
            throw new Error("Organization ID not found");
        }
        
        const response = await axios.get(`${url.GET_TRAININGS_BY_MONTH}`, {
            params: {
                organizationId: organizationId,
                year: year,
                month: month
            },
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'X-Organization-ID': organizationId
            }
        });
        
        return response.data;
    } catch (error) {
        console.error("Error fetching trainings by month:", error);
        throw error;
    }
};

// Update training (status + editable fields)
export const updateTrainingStatus = async (trainingId, statusData) => {
    try {
        const authUser = JSON.parse(localStorage.getItem("authUser"));
        const organizationId = authUser?.organizationId || authUser?.organization?.id;
        
        const response = await axios.put(`${url.UPDATE_TRAINING}`, {
            id: trainingId,
            ...statusData
        }, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${localStorage.getItem('token')}`,
                'X-Organization-ID': organizationId
            }
        });
        
        return response.data;
    } catch (error) {
        console.error("Error updating training:", error);
        throw error;
    }
};

// Fetch exam data for a specific batch
export const fetchBatchExamData = (batchId, fromDate = null, toDate = null) => {
    let params = { batchId };
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    return axios.get('/api/exams/batch-exams', { params });
};

// Fetch all exams with batch info
export const fetchAllExamsWithBatchInfo = (organizationId, fromDate = null, toDate = null) => {
    let params = { organizationId };
    if (fromDate) params.fromDate = fromDate;
    if (toDate) params.toDate = toDate;
    return axios.get('/api/exams/all-with-batch', { params });
};

// Fetch exam attempts by batch
export const fetchExamAttemptsByBatch = (batchId) => {
    return axios.get(`/api/exam-attempts/batch/${batchId}`);
};